import { Container, Flex, Link as ChakraLink } from "@chakra-ui/layout";
import {
  IconButton,
  useColorMode,
  useColorModeValue,
  useMediaQuery,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuIcon } from "../components/icons/MenuIcon";
import Sidebar from "../components/Sidebar";
import { darkMode, lightMode } from "../lib/models/color-mode-colors";
import logoWhite from "../logo-white.svg";
import logo from "../logo.svg";

function AuthenticatedLayout(props: any) {
  const location = useLocation();
  const { oktaAuth } = useOktaAuth();
  const [isLargerThan1280] = useMediaQuery("(min-width: 1281px)");
  const [isOpen, setIsOpen] = React.useState(false);
  const [currentPath, setCurrentPath] = React.useState(location.pathname);
  axios.defaults.headers.common["Limakey"] = oktaAuth.getAccessToken();

  const { colorMode } = useColorMode();
  const bgColor = useColorModeValue(lightMode[300], darkMode[300]);
  const headerBgColor = useColorModeValue(lightMode[100], darkMode[300]);
  const headerBorderColor = useColorModeValue(lightMode[200], darkMode[100]);

  axios.interceptors.request.use(function (config) {
    if (config.headers.common.Limakey === undefined) {
      throw new axios.Cancel(
        "Please log in to continue using the Pricing Engine"
      );
    }
    return config;
  });

  React.useEffect(() => {
    if (currentPath !== location.pathname) {
      setIsOpen(false);
      setCurrentPath(location.pathname);
    }
  }, [location, currentPath]);

  const handleSidebarToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Flex
        as="header"
        display={{ base: "flex", xl: "none" }}
        paddingX={8}
        paddingY={4}
        background={headerBgColor}
        justifyContent="space-between"
        boxShadow="sm"
        borderBottom="1px"
        borderBottomStyle="solid"
        borderBottomColor={headerBorderColor}
      >
        <ChakraLink as={Link} to="/quotes/my-quotes" marginLeft={6}>
          <img
            width="155"
            height="auto"
            src={colorMode === "light" ? logo : logoWhite}
            alt="Lima One Capital Logo"
          />
        </ChakraLink>

        <IconButton
          variant="unstyled"
          display={{ base: "block", "1281px": "none" }}
          aria-label="Open Navigation"
          onClick={() => setIsOpen(!isOpen)}
          icon={<MenuIcon h={8} w={8} color="brand.500" />}
          zIndex={299}
          borderRadius="full"
        />
      </Flex>

      <Sidebar isOpen={isOpen} onToggle={handleSidebarToggle} />
      <MainContainer
        isDesktop={isLargerThan1280}
        id="main-container"
        bg={bgColor}
      >
        <LayoutWrapper>
          <Container
            position="relative"
            maxW="1600px"
            paddingX={{ base: 4, md: 8 }}
          >
            {props.children}
          </Container>
        </LayoutWrapper>
      </MainContainer>
    </>
  );
}

export default AuthenticatedLayout;

const LayoutWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

const MainContainer = styled.main<{ isDesktop: boolean; bg: string }>`
  display: flex;
  flex: 1 1 auto;
  height: ${(props) => (props.isDesktop ? "100vh" : "calc(100vh - 80px)")};
  overflow: auto;
  scroll-behavior: smooth;
  margin-left: 275px;
  background: ${(props) => props.bg} !important;

  @media (max-width: 1280px) {
    margin-left: 0;
  }
`;
